export default __webpack_public_path__ + "static/media/conqueroraction.335ba9e9.png";